enum SystemType {
  Rooftop = 'Rooftop',
  Ground = 'Ground',
  Carport = 'Carport',
  Parktop = 'Parktop',
}

export default SystemType;
